import { useQuery } from "@tanstack/react-query"
import { segmentGroupCompareQuery } from "../lib/segmentGroupCompareQuery"

export function useSegmentGroupCompareQuery(...args: Parameters<typeof segmentGroupCompareQuery>) {
  return useQuery(segmentGroupCompareQuery(...args))
}
